module.exports = {"610481001":"东城街道","610481002":"西城街道","610481003":"店张街道","610481004":"西吴街道","610481005":"马嵬街道","610481101":"赵村镇","610481102":"桑镇","610481104":"南市镇","610481105":"庄头镇","610481106":"南位镇","610481107":"阜寨镇","610481108":"丰仪镇","610481109":"汤坊镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/610481.json
// module id = 2956
// module chunks = 0